import { Controller } from "@hotwired/stimulus"

/**
 * Une rangée qui défile horizontalement (viewport) : l'élément porte les directions libres,
 * `data-can-scroll-left` / `data-can-scroll-right`, d'où le CSS déduit flèches et fondus ;
 * les flèches font défiler d'une largeur visible.
 *
 * Recalculé au défilement, au redimensionnement et quand un frame imbriqué charge (la rangée
 * s'allonge d'une page).
 *
 * Usage :
 *   <div data-controller="scroller" data-action="turbo:frame-load->scroller#update" class="group/scroller">
 *     <div data-scroller-target="viewport" data-action="scroll->scroller#update" class="overflow-x-auto">…</div>
 *     <button data-action="scroller#previous" class="hidden group-data-[can-scroll-left]/scroller:flex">‹</button>
 *     <button data-action="scroller#next" class="hidden group-data-[can-scroll-right]/scroller:flex">›</button>
 *   </div>
 */
export default class extends Controller {
  static targets = ["viewport"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.viewportTarget)
    this.update()
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewportTarget
    this.element.toggleAttribute("data-can-scroll-left", scrollLeft > 1)
    this.element.toggleAttribute("data-can-scroll-right", scrollLeft + clientWidth < scrollWidth - 1)
  }

  previous() {
    this.viewportTarget.scrollBy({ left: -this.viewportTarget.clientWidth, behavior: "smooth" })
  }

  next() {
    this.viewportTarget.scrollBy({ left: this.viewportTarget.clientWidth, behavior: "smooth" })
  }
}
